import type { UserService } from '@captivateiq/assistant';

import type { GetCurrentUserResponse } from 'services/users';

export class TQUserServiceAdapter implements UserService {
  private user: GetCurrentUserResponse;

  constructor(user: GetCurrentUserResponse) {
    this.user = user;
  }

  async getCurrentUser() {
    return {
      id: this.user.id,
      name: [this.user.first_name, this.user.last_name].filter(Boolean).join(' '),
      email: this.user.email,
    };
  }
}
